import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  Shop,
  DoorOpenFill,
  DoorClosedFill,
  CheckCircleFill,
  BasketFill,
} from "react-bootstrap-icons";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import SupplierTable from "../../../Tables/UserPart/UserList/SupplierTable/SupplierTable";
import Button from "../../../Button/Button";
import {
  deactivateUserPostApi,
  getSupplierInfoApi,
  getSupplierListApi,
  getWalletInfoApi,
  updateSupplierOpenApi,
} from "../../../../Api/PanelAdminServices";
import SupplierInfo from "../../../Modal/Information/SupplierInfo/SupplierInfo";
import ShabaModal from "../../../Modal/Information/ShabaModal/ShabaModal";
import WalletInfo from "../../../Modal/Information/WalletInfo/WalletInfo";
import HandleMoney from "../../../Modal/Information/HandleMoney/HandleMoney";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import styles from "./SupplierContainer.module.scss";

const SupplierContainer = () => {
  const [rawInfo, setRawInfo] = useState(null);
  const [supplierList, setSupplierList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [scoreVisible, setScoreVisible] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const [userId, setUserId] = useState(null);
  const [wallet, setWallet] = useState([]);
  const [moneyVisible, setMoneyVisible] = useState(false);
  const [supplierDetail, setSupplierDetail] = useState(null);
  const [shabaAvailable, setShabaAvailable] = useState(false);
  const [disable, setDisable] = useState(false);
  const [updatingOpenId, setUpdatingOpenId] = useState(null);

  const history = useHistory();

  useEffect(() => {
    getSupplierList();
  }, []);

  const getSupplierList = () => {
    setLoading(true);
    getSupplierListApi((succ, res) => {
      setLoading(false);
      if (succ) {
        if (res?.status === 0) {
          errorToast("مشکلی در دریافت اطلاعات تأمین‌کنندگان پیش آمده است");
        } else {
          setSupplierList(res?.suppliers || []);
        }
      } else {
        errorToast("خطایی در ارتباط با سرور رخ داده است");
      }
    });
  };

  // Toggle store open/close API
  const handleToggleOpen = (record, newOpenState) => {
    const supplierId = record.id || record.key;
    setUpdatingOpenId(supplierId);

    const payload = {
      id: supplierId,
      open: newOpenState, // 0 or 1
    };

    updateSupplierOpenApi(payload, (success, res) => {
      setUpdatingOpenId(null);
      if (success && (res?.status === 1 || res?.status === "1")) {
        succToast(
          res?.message ||
            (newOpenState === 1
              ? "فروشگاه با موفقیت باز شد."
              : "فروشگاه با موفقیت بسته شد.")
        );
        // Optimistically update the list
        setSupplierList((prevList) =>
          prevList.map((sup) =>
            sup.id === supplierId ? { ...sup, open: String(newOpenState) } : sup
          )
        );
      } else {
        errorToast(res?.message || "خطا در تغییر وضعیت فروشگاه.");
      }
    });
  };

  // Actions handler
  const showAddress = async (actionId, info) => {
    setRawInfo(info);
    setUserId(info.key || info.id);

    // Fetch supplier info for modals and edit
    getSupplierInfoApi(info.key || info.id, (succ, res) => {
      if (succ) {
        if (res?.status === 0) {
          errorToast(res?.message || "اطلاعات دریافت نشد.");
        } else {
          setSupplierDetail(res?.info);

          // Edit action
          if (actionId === 2) {
            history.push(`/editsupplierinfo/${info.key || info.id}`, res?.info);
          }
        }
      } else {
        errorToast("خطایی در دریافت اطلاعات تأمین‌کننده رخ داد.");
      }
    });

    // Wallet
    if (actionId === 1) {
      getWalletInfoApi(info.id || info.key, (succ, res) => {
        if (succ) {
          if (res?.status === 0) {
            errorToast("مشکلی در دریافت کیف پول رخ داد.");
          } else {
            const sorted = (res?.transactions || []).sort((a, b) =>
              b.id > a.id ? 1 : -1
            );
            setWallet(sorted);
            setScoreVisible(true);
          }
        } else {
          errorToast("خطایی در سرور رخ داده است.");
        }
      });
    }

    // Deactivate/Activate user
    if (actionId === 3) {
      setDeleteVisible(true);
    }

    // User details modal
    if (actionId === 4) {
      setUserInfo(true);
    }

    // Shaba modal
    if (actionId === 5) {
      setShabaAvailable(true);
    }

    // Handle money modal
    if (actionId === 9) {
      setMoneyVisible(true);
    }
  };

  const deactiveCustomer = () => {
    if (!userId || !rawInfo) return;
    setDisable(true);
    const info = {
      id: userId,
      status: rawInfo.status === "0" ? "1" : "0",
      type: "supplier",
    };

    deactivateUserPostApi(info, (res) => {
      setDisable(false);
      setDeleteVisible(false);
      if (res?.status === 1) {
        succToast("وضعیت کاربر با موفقیت تغییر کرد.");
        getSupplierList();
      } else {
        errorToast(res?.message || "مشکلی در تغییر وضعیت کاربر پیش آمد.");
      }
    });
  };

  const handleCloseModals = () => {
    setDeleteVisible(false);
    setScoreVisible(false);
    setShabaAvailable(false);
    setUserInfo(false);
    setMoneyVisible(false);
  };

  // Prepare table data
  const data = (supplierList || []).map((item) => {
    const isStoreOpen = String(item.open) === "1" || item.open === 1;
    const totalMoney =
      (parseInt(item.deposited, 10) || 0) +
      (parseInt(item.withdrawaled, 10) || 0);

    return {
      key: item.id,
      id: item.id,
      fName: `${item.first_name || ""} ${item.last_name || ""}`.trim() || "—",
      marketName: item.name || "بدون نام",
      phone: item.phone || "—",
      signUpDate: item.register_date || "—",
      type: item.type === "food" ? "رستوران" : "فروشگاه",
      typeUrl: item.type,
      countProduct: item.total_product,
      totalOrder: item.total_order,
      status: item.status,
      money: separate(totalMoney),
      name: item.name,
      city: item.city_name || "—",
      open: item.open,
      isOpen: isStoreOpen,
    };
  });

  // KPI Statistics
  const totalCount = supplierList.length;
  const openCount = supplierList.filter(
    (s) => String(s.open) === "1" || s.open === 1
  ).length;
  const closedCount = totalCount - openCount;
  const activeCount = supplierList.filter((s) => s.status === "1").length;
  const restaurantCount = supplierList.filter((s) => s.type === "food").length;
  const supermarketCount = totalCount - restaurantCount;

  return (
    <div className={styles.container}>
      <TableFixedPage title="لیست تأمین‌کنندگان" />

      {/* KPI Overview Cards */}
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statInfo}>
            <p className={styles.statTitle}>کل تأمین‌کنندگان</p>
            <p className={styles.statValue}>{totalCount}</p>
          </div>
          <div className={`${styles.statIcon} ${styles.iconTotal}`}>
            <Shop />
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statInfo}>
            <p className={styles.statTitle}>فروشگاه‌های باز</p>
            <p className={styles.statValue}>{openCount}</p>
          </div>
          <div className={`${styles.statIcon} ${styles.iconOpen}`}>
            <DoorOpenFill />
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statInfo}>
            <p className={styles.statTitle}>فروشگاه‌های بسته</p>
            <p className={styles.statValue}>{closedCount}</p>
          </div>
          <div className={`${styles.statIcon} ${styles.iconClosed}`}>
            <DoorClosedFill />
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statInfo}>
            <p className={styles.statTitle}>کاربران فعال</p>
            <p className={styles.statValue}>{activeCount}</p>
          </div>
          <div className={`${styles.statIcon} ${styles.iconActive}`}>
            <CheckCircleFill />
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statInfo}>
            <p className={styles.statTitle}>رستوران / فروشگاه</p>
            <p className={styles.statValue}>
              {restaurantCount} / {supermarketCount}
            </p>
          </div>
          <div className={`${styles.statIcon} ${styles.iconFood}`}>
            <BasketFill />
          </div>
        </div>
      </div>

      {/* Table Card Wrapper */}
      <div className={styles.tableCard}>
        <SupplierTable
          showAddress={showAddress}
          data={data}
          onToggleOpen={handleToggleOpen}
          updatingOpenId={updatingOpenId}
        />
      </div>

      {/* Deactivate User Modal */}
      <Modal show={deleteVisible} onHide={handleCloseModals} centered dir="rtl">
        <Modal.Header closeButton>
          <Modal.Title className={styles.modalTitle}>
            {rawInfo?.status === "1"
              ? "غیرفعال‌سازی حساب تأمین‌کننده"
              : "فعال‌سازی مجدد حساب تأمین‌کننده"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ textAlign: "center", fontSize: "14px", margin: "12px 0" }}>
            {rawInfo?.status === "1"
              ? "آیا از غیرفعال کردن کاربر موردنظر مطمئن هستید؟"
              : "آیا از فعال‌سازی مجدد کاربر موردنظر مطمئن هستید؟"}
          </p>
          <div className={styles.modalButtons}>
            <Button
              ClassBtn="rejectBtn"
              Value="انصراف"
              ClickHandler={handleCloseModals}
            />
            <Button
              ClassBtn="confirmBtn"
              Value="تأیید"
              ClickHandler={deactiveCustomer}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* Supplier Info Modal */}
      <Modal show={userInfo} onHide={handleCloseModals} size="lg" centered dir="rtl">
        <Modal.Header closeButton>
          <Modal.Title className={styles.modalTitle}>
            اطلاعات جامع تأمین‌کننده
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {supplierDetail && (
            <SupplierInfo Info={supplierDetail} handleOk={handleCloseModals} />
          )}
        </Modal.Body>
      </Modal>

      {/* Shaba Modal */}
      <Modal show={shabaAvailable} onHide={handleCloseModals} centered dir="rtl">
        <Modal.Body>
          {supplierDetail && (
            <ShabaModal type="supplier" data={supplierDetail} />
          )}
        </Modal.Body>
      </Modal>

      {/* Wallet Transactions Modal */}
      <Modal show={scoreVisible} onHide={handleCloseModals} size="lg" centered dir="rtl">
        <Modal.Header closeButton>
          <Modal.Title className={styles.modalTitle}>
            تراکنش‌های کیف پول
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WalletInfo data={wallet} />
        </Modal.Body>
      </Modal>

      {/* Handle Money (Reward / Penalty) Modal */}
      <Modal show={moneyVisible} onHide={handleCloseModals} centered dir="rtl">
        <Modal.Header closeButton>
          <Modal.Title className={styles.modalTitle}>
            تشویق و جریمه (شارژ / کسر موجودی)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HandleMoney
            uType="supplier"
            userId={userId}
            close={handleCloseModals}
            onUpdate={getSupplierList}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SupplierContainer;
